/**
 * dg-infinite-scroll.js
 * Infinite scroll for collection and search pages.
 *
 * Auto-chains near-empty pages (when WLM/filters hide most products) so the
 * user sees one continuous load instead of many observer round-trips.
 */

(function () {
  'use strict';

  const GRID_SELECTOR     = '#dg-products-grid, #dg-search-grid';
  const SENTINEL_SELECTOR = '#dg-infinite-sentinel';
  const SPINNER_ID        = 'dg-infinite-spinner';
  const MIN_APPENDED      = 6;
  const MAX_CHAIN         = 25;

  const grid = document.querySelector(GRID_SELECTOR);
  if (!grid) return;

  const sentinel = document.querySelector(SENTINEL_SELECTOR);
  if (!sentinel) return;

  let loading  = false;
  let nextUrl  = sentinel.dataset.next || null;

  if (!nextUrl) {
    sentinel.hidden = true;
    return;
  }

  function showSpinner() {
    let sp = document.getElementById(SPINNER_ID);
    if (!sp) {
      sp = document.createElement('div');
      sp.id = SPINNER_ID;
      sp.innerHTML = '<div class="dg-infinite-spinner__dot"></div><div class="dg-infinite-spinner__dot"></div><div class="dg-infinite-spinner__dot"></div>';
      sp.className = 'dg-infinite-spinner';
      sentinel.parentNode.insertBefore(sp, sentinel);
    }
    sp.hidden = false;
  }

  function hideSpinner() {
    const sp = document.getElementById(SPINNER_ID);
    if (sp) sp.hidden = true;
  }

  async function fetchPage(url) {
    const res  = await fetch(url);
    const text = await res.text();
    const doc  = new DOMParser().parseFromString(text, 'text/html');

    const newGrid     = doc.querySelector(GRID_SELECTOR);
    const newSentinel = doc.querySelector(SENTINEL_SELECTOR);

    let appended = 0;
    if (newGrid) {
      while (newGrid.firstChild) {
        const node = newGrid.firstChild;
        if (node.nodeType === 1) appended++;
        grid.appendChild(node);
      }
    }

    const next = newSentinel ? (newSentinel.dataset.next || null) : null;
    return { appended, next };
  }

  async function loadMore() {
    if (loading || !nextUrl) return;
    loading = true;
    showSpinner();

    try {
      let chain = 0;
      while (nextUrl && chain < MAX_CHAIN) {
        const { appended, next } = await fetchPage(nextUrl);
        nextUrl = next;
        sentinel.dataset.next = nextUrl || '';
        chain++;
        if (appended >= MIN_APPENDED) break;
      }

      if (!nextUrl) {
        sentinel.hidden = true;
        observer.disconnect();
      }
    } catch (e) {
      console.warn('[DG Infinite Scroll] Fetch error:', e);
    } finally {
      loading = false;
      hideSpinner();
    }
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) loadMore();
      });
    },
    { rootMargin: '200px' }
  );

  observer.observe(sentinel);

})();
